import React from 'react';
import { FileText, Share2, Mail, Building2, Upload, Clock } from 'lucide-react';

const icons = {
  records: FileText,
  permissions: Share2,
  email: Mail,
  requests: Building2,
  upload: Upload,
  activity: Clock
};

export default function EmptyState({
  icon = 'records',
  title,
  description,
  actions = [],
  compact = false
}) {
  const Icon = icons[icon] || FileText;

  if (compact) {
    return (
      <div className="text-center py-10">
        <div className="w-10 h-10 bg-slate-100 rounded-xl flex items-center justify-center mx-auto mb-3">
          <Icon className="w-5 h-5 text-slate-400" />
        </div>
        <p className="text-slate-600 font-medium text-sm">{title}</p>
        {description && <p className="text-xs text-slate-400 mt-1">{description}</p>}
        {actions.length > 0 && (
          <div className="flex gap-2 justify-center mt-4">
            {actions.map((action, i) => (
              <button
                key={i}
                onClick={action.onClick}
                className={`px-3.5 py-2 text-sm font-medium rounded-xl transition-all ${
                  action.primary
                    ? 'bg-gradient-to-r from-brand-600 to-violet-600 text-white hover:shadow-glow-blue'
                    : 'text-brand-600 hover:bg-brand-50'
                }`}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-slate-200/60 p-14 text-center shadow-card">
      <div className="w-16 h-16 bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
        <Icon className="w-7 h-7 text-slate-400" />
      </div>
      <h3 className="text-lg font-semibold text-slate-900 mb-2 tracking-tight">{title}</h3>
      {description && (
        <p className="text-sm text-slate-400 mb-6 max-w-sm mx-auto leading-relaxed">{description}</p>
      )}
      {actions.length > 0 && (
        <div className="flex gap-3 justify-center">
          {actions.map((action, i) => (
            <button
              key={i}
              onClick={action.onClick}
              className={`px-5 py-2.5 font-medium rounded-xl flex items-center gap-2 transition-all text-sm ${
                action.primary
                  ? 'bg-gradient-to-r from-brand-600 to-violet-600 text-white hover:shadow-glow-blue'
                  : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 hover:border-slate-300'
              }`}
            >
              {action.icon && <action.icon className="w-4 h-4" />}
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
